
import React from "react";
import "./CreateClient.css";

type propsData = {
    hashtags: string,
    setHashtags: (hashtags: string) => void,
    notes: string
    setNotes: (notes: string) => void,
}

function HashtagCustomerNotes({ hashtags, notes, setNotes, setHashtags }: propsData ) {
    return(
        <div className="HashtagCustomerNotes">
            <div className="createClient-form-type mrg-btm">
                <div className="form-type-box">
                    <label># Hashtags</label>
                </div>
                <div className = "form-type-box">
                    <input
                        className = "type-box-type-input"
                        type = "text"
                        value = { hashtags }
                        onChange = {e => setHashtags(e.target.value)}
                    />
                </div>
            </div>
            <div className="createClient-form-type mrg-btm">
                <div className="form-type-box">
                    <label>Additional Notes</label>
                </div>
                <div className="form-type-box">
                    <textarea
                        style = {{
                            resize: "none",
                            height: "80px",
                            outline: "none"
                        }}
                        className = "type-box-type-input"
                        value = { notes }
                        onChange = {e => setNotes(e.target.value)}
                    />
                </div>
            </div>
        </div>
    )
}

export default HashtagCustomerNotes
